import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const apiKeyImporterSelectors = importerSelectors(
  'apiKey.importer',
);

export default apiKeyImporterSelectors;
